module.exports = __webpack_public_path__ + "c1829ac9199dab3addf3c5cc0bffc36e.fbx";